import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IPartnerBox } from '../interfaces';
import { PartnerBoxMapper } from '../mappers';

export type IGetPartnerBoxesRepoResponse = IRepoResponse<200, { data: IPartnerBox[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetPartnerBoxesRepo = IRepo<[any], IGetPartnerBoxesRepoResponse>;

export const GetPartnerBoxesRepoType = Symbol.for('GetPartnerBoxesRepo');

@bind(GetPartnerBoxesRepoType)
export class GetPartnerBoxesRepo implements IGetPartnerBoxesRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/branchpartner/containers', query) });

      if (result.status === 200) {
        const data: IPartnerBox[] = result.data.data.map((user) => PartnerBoxMapper.toDomain(user));
        const total: number = result.data.total;

        return {
          status: 200 as 200,
          response: {
            data,
            total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
